module.exports = __webpack_public_path__ + "static/media/ConveyerBelt_Transparent-01.921e7482.png";